import { actionCreators } from './actionCreators';
import { reducer } from './reducer';

const reservationsStore = {
    actionCreators,
    reducer,
};

export default reservationsStore;
